




























import { Component, Vue, Watch } from 'vue-property-decorator';
import Container from '@/components/Container.vue';
import SearchParametersTab from './SearchParametersTab.vue';
import DownloadSettingsTab from './DownloadSettingsTab.vue';

const tabs = [{ tab: 'Search Parameters' }, { tab: 'Download Settings' }];

@Component({
  components: {
    Container,
    SearchParametersTab,
    DownloadSettingsTab
  }
})
export default class AdminThirdPartyManagement extends Vue {
  public activeTab = 0;

  public mounted() {
    if (this.$route.query.tab) {
      const index = tabs.findIndex((res) => res.tab === this.$route.query.tab);

      if (index >= 0) {
        this.activeTab = +index;
      }
    }
  }

  public isTabDisabled(index: number): boolean {
    return this.activeTab !== index;
  }

  async handleBackRedirect() {
    this.$router.go(-1);
  }

  @Watch('activeTab')
  public onTabChange(value: number) {
    if (this.$route.query.tab === tabs[value].tab) {
      return;
    }
    this.$router.replace({
      query: { ...(tabs as { [key: string]: any })[value] }
    });
  }
}
